import React, { useEffect, useState } from 'react';
import { useConfig } from '../contexts/ConfigContext';
import { useCompany } from '../contexts/CompanyContext';
import SideBar from '../components/SideBar';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer'
import { app } from '../config/const';
import { contentPath, modules } from '../config/pages';
import useAuth from '../hooks/useAuth';
import { useUser } from '../contexts/UserContext';
import { Layout, Spin } from "antd";
import { useHistory } from 'react-router-dom';
import Forbidden from './Forbidden';

const { Content } = Layout;

const navOptions = [
  modules.BotList,
  modules.ToolList,
  modules.ContactList,
  modules.ChatList,
];

const Index = (props:any) => {

  const { config,updateConfig } = useConfig()
  const {company,updateCompany} = useCompany()
  const {updateUser} = useUser()
  const [isForbidden, setIsForbidden] = useState(false)
  const history = useHistory()
  const companyUidFromQuery = new URLSearchParams(globalThis.location.search).get('company');
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data:indexData} = useAuth.useIndex(tokenData,{
    session:config.session,
    company: companyUidFromQuery || company.current.uid,
    module: config.module || 'INDEX'
  })
  
  useEffect(()=>{
    if(tokenData && indexData?.user){
      const targetUid = companyUidFromQuery || company.current.uid;
      const defaultCompany = indexData.companies.find((comp: any) => 
        indexData.permissions?.some((el: any) => el.key.toUpperCase().startsWith(app.Wpbot) && el.company_id === comp.id) &&
        indexData.modules?.some((mod: any) => mod.app.toUpperCase() === app.Wpbot && mod.company_id === comp.id)
      ) ?? indexData.companies.find((comp: any) => 
        indexData.permissions?.some((el: any) => el.key.toUpperCase().startsWith(app.Wpbot) && el.company_id === comp.id)
      ) ?? indexData.companies.find((comp: any) => 
        indexData.modules?.some((mod: any) => mod.app.toUpperCase() === app.Wpbot && mod.company_id === comp.id)
      ) ?? indexData.companies[0];
      const currentCompany = targetUid ? (indexData.companies.find((comp: any) => comp.uid === targetUid) ?? defaultCompany) : defaultCompany;
      const currentModule = indexData.modules.find((mod:any) => mod.app.toUpperCase() === app.Wpbot && mod.company_id === currentCompany.id)

      currentCompany.modules = indexData.modules.filter((mod:any) => mod.company_id === currentCompany.id)
      if (indexData.subscriptions) {
        currentCompany.subscription = indexData.subscriptions.find((sub:any) => sub.company_id === currentCompany.id)
      }

      updateConfig({key:tokenData.key,module: props.module,showProgress:false})
      const userViews: string[] = indexData.permissions.filter((el:any) => el.type === 'VIEW' && el.company_id === currentCompany.id).map((el:any) => el.key);
      updateUser({...indexData.user,
        permissions:{
          views: userViews,
          actions: indexData.permissions.filter((el:any) => el.type === 'ACTION' && el.company_id === currentCompany.id).map((el:any) => el.key)
        },
        roles:indexData.permissions
      })
      updateCompany({
        current:{...currentCompany},
        list:indexData.companies,
        moduleList:indexData.modules,
        currentModule:currentModule,
        moduleOptions:[]
      })
      if(indexData?.permissions){
        const modulePermission = indexData.permissions?.some((el:any) => el.key.toUpperCase().startsWith(app.Wpbot) && el.company_id === currentCompany.id)
        const hasModule = Boolean(currentModule)
        if(!modulePermission || !hasModule){
          setIsForbidden(true)
        } else {
          setIsForbidden(false)
          if(props.module === modules.BotList && !userViews.some((v: string) => v.toLowerCase().includes(modules.BotList.toLowerCase()))){
            const firstAvailable = navOptions.find(key => userViews.some(v => v.toLowerCase().includes(key.toLowerCase())));
            if(firstAvailable){
              history.replace(contentPath[firstAvailable]);
            }
          }
        }
      }
      console.log(indexData)
    }
  },[tokenData,indexData,config.showProgress])

  const getPadding = () => {
    if(config.sideVisible && !config.isMobile){
      if(config.sideCollapsed){
        return 80
      }else{
        return 250
      }
    }
    if(config.sideVisible && config.isMobile){
      return 80
    }
    return 0
  }
  const MainContent = isForbidden ? Forbidden : props.content

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      {!isForbidden && config.sideVisible && <SideBar/>}
      <Spin size="large" tip="Cargando..."  fullscreen spinning={config.showProgress}/>
      {/* Contenedor Principal */}
      <Layout style={{ paddingLeft: !isForbidden ? getPadding() : 0, transition: "0.3s" }}>
        {/* Header */}
 
        <TopBar></TopBar> 

        {/* Contenido */}
        <Content style={{ 
          margin: config.isMobile ? "8px 4px" : "16px", 
          padding: config.isMobile ? "12px 8px" : "24px", 
          background: "#fff", 
          minHeight: "calc(100vh - 112px)", 
          borderRadius: config.isMobile ? 4 : 8
        }}>
          <MainContent />
        </Content>

        {/* Footer */}
        <Footer />
      </Layout>

    </Layout>
  )
}

export default Index;
